import styled, { css } from 'styled-components';
import { absFull } from 'helpers/styles.js';

export const PickerContainer = styled.div`
  max-width: 1000px;
  width: 100%;
  height: 600px;
  padding: 40px 80px;
  background: white;
  position: relative;
`;

export const StyledType = styled.div`
  text-transform: capitalize;
  font-size: 9px;
  line-height: 18px;
  text-align: center;
  color: #939AAB;
`;

export const StyledName = styled.div`
  font-size: 12px;
  text-align: center;
  color: #446D93;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 100;
`;

export const TileContainer = styled.div`
  position: relative;
  display: inline-block;
  vertical-align: top;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
  font-size: 10px;
  height: 170px;
  text-align: center;
  cursor: pointer;
  padding: 0 12px;
  transition: all .2s ease;
  width: 18%;
  margin: 1%;

  &:hover {
    transform: translateY(-2px);
  }

  ${({ selected, theme }) => selected ? css`
    background: ${theme.colors.palette[7]};

    ${StyledName},
    ${StyledType} {
    color: white;
    }
  ` : null}
`;

export const StyledLogo = styled.div`
  position: relative;
  border-radius: 100%;
  overflow: hidden;
  width: 70px;
  height: 70px;
  margin: 35px auto 16px;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.08);
`;

export const PickerColumn = styled.div`
  width: 100%;
  display: inline-block;
  vertical-align: top;

  &:only-child {
    width: 100%;
    display: block;
  }
`;

export const TilesContainer = styled.div`
  text-align: left;
  position: relative;
  margin: auto;
  height: 320px;
  overflow: hidden;

  ${({ halfLayout }) => halfLayout ? css`
    ${PickerColumn} {
      width: 50%;
    }

    ${TileContainer} {
      width: 31.33%;

      @media (max-width: 1100px) {
        width: 48%;
      }
    }
  ` : null}

`;

export const ButtonContainer = styled.div`
  ${absFull('auto', 0, 0, 0)};
  height: 80px;
  text-align: right;
  line-height: 80px;
  padding: 0 26px;
  background: #fafafa;
`;

export const ModalButton = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 9px;
  line-height: 13px;
  letter-spacing: 2px;
  color: #CBCED6;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px rgba(0,0,0,0.1);
  border-radius: 20px;
  display: inline-block;
  padding: 6px 16px;
  cursor: pointer;
  transition: all .3s ease;

  ${({ canSubmit, theme }) => canSubmit && css`
    background: ${theme.colors.palette[7]};
    color: white;
  `};
`;

export const SelectedBar = styled.div`
  min-height: 30px;
  background: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.07);
  border-radius: 10px;
  margin-bottom: 18px;
  line-height: 30px;
  text-align: left;
  padding: 0 16px;
`;


export const SelectedText = styled.div`
  font-size: 10px;
  color: #2D8BFF;
  display: inline-block;
  vertical-align: top;
  margin-top: 5px;
  margin-right: 8px;
`;
